import { forwardRef } from 'react';

export const useFileUpload = () => {
  const handleImportFile = (fileInputRef) => {
    if (!fileInputRef || !fileInputRef.current) {
      console.error('Hidden input file ref is missing');
      return;
    }
    fileInputRef.current.click();
  };

  const handleOnDragOver = (event) => {
    event.preventDefault();
  };

  const handleOnDrop = ({ event = null, multiple = false }) => {
    if (!event) return;
    event.preventDefault();
    const files = event.dataTransfer.files;
    if (multiple) {
      return files;
    }
    return files[0];
  };

  const handleFileChange = ({ event = null, multiple = false }) => {
    if (!event) return;
    event.stopPropagation();
    const files = event.target.files;
    if (multiple) {
      return files;
    }
    return files[0];
  };

  const HiddenInputFile = forwardRef(function HiddenInputFile(props, ref) {
    const { name = 'input-file-id', id = 'input-file-id', multiple = false, onChange = () => {} } = props;

    return (
      <input
        type="file"
        name={name}
        id={id}
        ref={ref}
        accept="*/*"
        multiple={multiple}
        style={{ visibility: 'hidden', width: 0, height: 0, pointerEvents: 'none' }}
        onChange={onChange}
      />
    );
  });

  return {
    handleImportFile,
    handleOnDragOver,
    handleOnDrop,
    handleFileChange,
    HiddenInputFile,
  };
};
